import React from 'react';
import { Phone, MapPin, Mail, Instagram, Facebook, Clock } from 'lucide-react';
import { foodTruckInfo, schedule } from '../data/mock';

const ContactPage = () => {
  return (
    <main className="pt-20 min-h-screen bg-[#0E0E0E]">
      {/* Hero */}
      <section className="py-20 bg-[#1A1A1A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#F7C948]/10 border border-[#F7C948]/30 text-[#F7C948] text-sm font-medium mb-6">
              <Mail size={16} />
              Contact
            </div>
            <h1 className="font-display text-5xl md:text-6xl font-extrabold text-white mb-4">
              Contactez-nous
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Une question ? Appelez-nous directement !
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            {/* Phone - Main CTA */}
            <div className="md:col-span-2 bg-gradient-to-br from-[#F7C948]/20 to-[#F7C948]/5 rounded-2xl p-8 border border-[#F7C948]/30 text-center">
              <div className="w-20 h-20 bg-[#F7C948]/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Phone size={40} className="text-[#F7C948]" />
              </div>
              <h2 className="font-display text-2xl font-bold text-white mb-2">
                Appelez-nous !
              </h2>
              <p className="text-gray-400 mb-6">
                Le moyen le plus rapide pour nous joindre
              </p>
              <a
                href={`tel:${foodTruckInfo.phone.replace(/\s/g, '')}`}
                className="inline-flex items-center gap-3 bg-[#F7C948] text-[#0E0E0E] px-8 py-4 rounded-xl font-bold text-xl hover:bg-[#FFE17D] transition-all duration-300 hover:shadow-lg hover:shadow-[#F7C948]/25"
              >
                <Phone size={24} />
                {foodTruckInfo.phone}
              </a>
            </div>

            {/* Address */}
            <div className="bg-[#1A1A1A] rounded-2xl p-6 border border-white/10 hover:border-[#F7C948]/30 transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#F7C948]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin size={28} className="text-[#F7C948]" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-white mb-2">Adresse</h3>
                  <p className="text-gray-300 mb-4">{foodTruckInfo.address}</p>
                  <a
                    href="https://maps.google.com/?q=429+Route+de+Bourg+01340+Malafretaz"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[#F7C948] font-medium hover:text-[#FFE17D] transition-colors duration-300"
                  >
                    Voir l'itinéraire →
                  </a>
                </div>
              </div>
            </div>

            {/* Schedule */}
            <div className="bg-[#1A1A1A] rounded-2xl p-6 border border-white/10 hover:border-[#F7C948]/30 transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#F7C948]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Clock size={28} className="text-[#F7C948]" />
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-lg font-bold text-white mb-3">Horaires</h3>
                  <div className="space-y-1.5">
                    {schedule.map((item) => (
                      <div
                        key={item.day}
                        className={`flex justify-between text-sm ${
                          item.open ? 'text-gray-300' : 'text-gray-500'
                        }`}
                      >
                        <span>{item.day}</span>
                        <span className={item.open ? 'text-[#F7C948]' : ''}>
                          {item.hours}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="md:col-span-2 bg-[#1A1A1A] rounded-2xl p-6 border border-white/10">
              <h3 className="font-display text-lg font-bold text-white mb-4 text-center">
                Suivez-nous sur les réseaux
              </h3>
              <div className="flex items-center justify-center gap-4">
                <a
                  href={foodTruckInfo.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 bg-[#F7C948]/10 px-6 py-3 rounded-xl text-[#F7C948] hover:bg-[#F7C948] hover:text-[#0E0E0E] transition-all duration-300"
                >
                  <Instagram size={24} />
                  <span className="font-medium">Instagram</span>
                </a>
                <a
                  href={foodTruckInfo.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 bg-[#F7C948]/10 px-6 py-3 rounded-xl text-[#F7C948] hover:bg-[#F7C948] hover:text-[#0E0E0E] transition-all duration-300"
                >
                  <Facebook size={24} />
                  <span className="font-medium">Facebook</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
